var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWriting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    clipPath: "url(#clip0_12519_21247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 16.9327V3.06555H14.5543L14.6105 3.00938C15.298 2.32184 15.298 1.20316 14.6105 0.515625C13.9229 -0.171875 12.8043 -0.171875 12.1167 0.515625L9.5668 3.06555H0V16.9327H8.24219V18.8273H5.27344V19.9991H14.7266V18.8273H11.7578V16.9327H20ZM12.9454 1.34426C13.176 1.11363 13.5512 1.11363 13.7818 1.34426C14.0124 1.57488 14.0124 1.95012 13.7818 2.18074L8.66934 7.2932L7.83285 6.45672L12.9454 1.34426ZM7.04734 7.32848L7.79762 8.07875L6.51441 8.61168L7.04734 7.32848ZM8.39492 4.23742L6.11555 6.51684L4.76746 9.76266L5.36352 10.3582V10.3586H14.1992V9.18676H8.185L8.6093 9.01055L13.3824 4.23742H18.8281V13.4171H1.17188V4.23742H8.39492ZM1.17188 15.7609V14.589H18.8281V15.7609H1.17188ZM10.5859 18.8273H9.41406V16.9327H10.5859V18.8273Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12519_21247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriting);
export default __webpack_public_path__ + "static/media/writing.75ddd37e60b949f37e1fe11284ec3aaa.svg";
export { ForwardRef as ReactComponent };